import React, { forwardRef } from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { optionColor, optionColorHover } from '../../../helpers/shared';

// Define element styles for the component
const StyledButton = styled.button`
  color: white !important;
  background-color: ${props => optionColor(props.color)} !important;
  border-color: ${props => optionColor(props.color)} !important;
  margin: 7px 0 !important;
  width: 100% !important;
  &:hover,
  &:active,
  &:focus,
  &:focus-visible {
    color: white !important;
    background-color: ${props => optionColorHover(props.color)} !important;
    border-color: ${props => optionColorHover(props.color)} !important;
  }
  padding: ${({padding}) => padding ? `${padding}px !important` : ''};
`;

/**
 * Button component with distinct colors
 * @component
 * @param {Element} children
 * @returns
 */
export const Button = forwardRef(({ children, ...props }, ref) => {
  return <StyledButton ref={ref} { ...props }>{ children }</StyledButton>;
});

Button.propTypes = {
  children: PropTypes.any
};